import React, { Component } from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import { components } from 'react-select'
import AsyncSelect from 'react-select/lib/Async'
import { Icon } from './'

const SelectWrapper = styled.div`
  width: 100%;
  margin: 0 0 30px 0;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: ${props => (props.paddingBottom ? props.paddingBottom : '0px')};
  & > div > div:first-child {
    background-color: #fbf8f1 !important;
    border: none !important;
    border-radius: 100px !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16) !important;
    min-height: 41px;
  }

  .css-11unzgr {
    padding: 0 !important;
  }
  .css-1bd67wx {
    color: #fff !important;
  }
  .css-1khxe72 {
    background-color: #fbf8f1 !important;
    border-radius: 100px !important;
    border: none !important;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16) !important;
  }
  .css-k136fc {
    border-radius: 100px !important;
    background-color: #fbf8f1 !important;
    min-height: 41px;
  }
  .css-15k3avv {
    background-color: #fbf8f1 !important;
  }
  .css-1ep9fjw {
    padding: 10px 14px !important;
  }
  .css-1hwfws3 {
    padding: 2px 18px !important;
  }
`

const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <Icon icon="search" />
      </components.DropdownIndicator>
    )
  )
}
class SelectBox extends Component {
  state = {}
  render() {
    const { selectField, paddingBottom, ...props } = this.props
    // console.log('dnsjbfh', this.props.loadOptions)
    return (
      <SelectWrapper paddingBottom={paddingBottom}>
        {selectField ? (
          <Select {...props} />
        ) : (
          <AsyncSelect
            theme={theme => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: '#068489',
                primary: '#068489'
              }
            })}
            components={{ DropdownIndicator }}
            {...props}
          />
        )}
      </SelectWrapper>
    )
  }
}

export default SelectBox



// WEBPACK FOOTER //
// ./src/components/SelectBox.js